export default __webpack_public_path__ + "media/Number8.5cb910de58a9956c4db99b7c5e4b0712.mp4";